<mat-dialog-content>
    <h2>Import Data <span *ngIf="selectedFileName">from {{selectedFileName}}</span></h2>

    <mat-stepper orientation="horizontal" linear #stepper (selectionChange)="stepChanged($event)">
        <mat-step [completed]="fileSelectionComplete">
            <ng-template matStepLabel>Select File</ng-template>
            <div class="step-container">
                <div class="button-container">
                    <input type="file" accept=".csv" style="display: none;" (change)="fileSelected($event)" #fileUpload>
                    <button mat-raised-button color="primary" (click)="resetReader(); fileUpload.click()" style="width: 100%;">Select File</button>
                </div>

                <div *ngIf="selectedFileName">
                    <table style="width: 100%;">
                        <tr>
                            <td>
                                Selected File
                            </td>
                            <td>
                                {{selectedFileName}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Total Rows
                            </td>
                            <td>
                                {{fileRows.length}}
                            </td>
                        </tr>
                    </table>

                </div>
            </div>

            <div class="button-container">
                &nbsp;
                <button mat-raised-button color="warn" (click)="cancel()">Cancel</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!fileSelectionComplete">Next</button>
            </div>
        </mat-step>

        <mat-step [completed]="tableSelectionComplete()">
            <div class="step-container">
                <ng-template matStepLabel>Select Table</ng-template>

                <mat-radio-group [(ngModel)]="importMode" (change)="modeChanged()" [value]="importMode">
                    <mat-radio-button [value]="ImportMode.NEW" [disabled]="!canCreateTable">Create new table</mat-radio-button>
                    <mat-radio-button [value]="ImportMode.APPEND">Append to existing table</mat-radio-button>
                    <mat-radio-button [value]="ImportMode.REPLACE">Overwrite existing table</mat-radio-button>
                </mat-radio-group>

                <div *ngIf="importMode === ImportMode.NEW" class="data-fields">
                    <mat-form-field>
                        <mat-label>Table Name</mat-label>
                        <input matInput name="tableName" [(ngModel)]="tableName" (keypress)="disallowSpaces($event)" (ngModelChange)="tableNameChanged()">
                    </mat-form-field>
            
                    <mat-form-field>
                        <mat-label>Table Description</mat-label>
                        <input matInput name="tableDescription" [(ngModel)]="tableDescription">
                    </mat-form-field>            
                </div>
            
                <div *ngIf="importMode !== ImportMode.NEW" class="data-fields">
                    <mat-form-field style="width: 400px;">
                        <mat-label *ngIf="importMode === ImportMode.APPEND">Select table to append to</mat-label>
                        <mat-label *ngIf="importMode === ImportMode.REPLACE">Select table to overwrite</mat-label>
                        <mat-select [(value)]="selectedTable" name="tableSelection" (selectionChange)="selectedTableChanged()">
                            <mat-option *ngFor="let table of tables" [value]="table">
                                {{table.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>


                <div *ngIf="tableNameInUse" class="centered-content-container">
                    The table name "{{tableName}}" is already in use.
                </div>
            </div>

            <div class="button-container">
                <button mat-raised-button color="primary" matStepperPrevious>Back</button>
                <button mat-raised-button color="warn" (click)="cancel()">Cancel</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!tableSelectionComplete()">Next</button>
            </div>
        </mat-step>

        <mat-step [completed]="validationComplete">
            <ng-template matStepLabel>Validate File</ng-template>
            <div class="step-container">

                <span *ngIf="keyFields.length === 0">
                    <h2>&nbsp;</h2>
                    &nbsp;
                </span>
                <span *ngIf="keyFields.length > 0">
                    <h2>Please select the primary key field(s)</h2>
                    The selected fields will be used to identify any duplicate rows
                </span>
            
                <div class="list-container">
                    <ul>
                        <li *ngFor="let field of keyFields">
                        <mat-checkbox [(ngModel)]="field.selected" (change)="keyFieldSelectionChanged()">
                            {{field.name}}
                        </mat-checkbox>
                        </li>
                    </ul>
                </div>

                <div *ngIf="!validationComplete" class="button-container">
                    <button mat-raised-button color="primary" (click)="validateFile().subscribe()" style="width: 100%;" [disabled]="!readyToValidate()">Validate File</button>
                </div>

                <div *ngIf="validationComplete" class="centered-content-container">
                    All validation checks passed!
                </div>
            </div>

            <div class="button-container">
                <button mat-raised-button color="primary" matStepperPrevious>Back</button>
                <button mat-raised-button color="warn" (click)="cancel()">Cancel</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!validationComplete || !readyToValidate()">Next</button>
            </div>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel>Import</ng-template>
            <div class="step-container">
                <div class="button-container">
                    <button mat-raised-button color="primary" (click)="import()" style="width: 100%;" [disabled]="importComplete">Import File</button>
                </div>

                <br>

                <div *ngIf="importMessage.length > 0" class="centered-content-container">
                    {{importMessage}}
                </div>
            </div>

            <div class="button-container">
                <button mat-raised-button color="primary" matStepperPrevious [disabled]="importComplete">Back</button>
                <button mat-raised-button color="warn" (click)="cancel()" [disabled]="importComplete">Cancel</button>
                <button mat-raised-button color="primary" (click)="done()" [disabled]="!importComplete">Done</button>
            </div>
        </mat-step>
    </mat-stepper>
</mat-dialog-content>